import React, { useContext, useEffect } from 'react';
import context from '../../context';
import styled from 'styled-components';
import { gsap } from 'gsap';
import { ArrowDownOutlined } from '@ant-design/icons';

import { Section } from '../../styled-components';
import FormProperty from '../forms/properties';
import heroImage from '../../images/pexels-chaitaastic-1918291.jpg';

const MainCont = styled(Section)`
  background-color: #fff;
  padding-bottom: 0;
`;

const HeroImageWrapper = styled.div`
  position: relative;
  height: 40vh;
  width: 100%;
  overflow: hidden;
`;

const HeroImage = styled.div`
  background-image: url(${props => props.$image});
  background-size: cover;
  background-position: center;
  height: 100%;
  width: 100%;
`;

const VideoOverLay = styled.div`
  position: absolute;  
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #d6eaf8;
  opacity: 0.1;
  z-index: 100;
`;

const DownLink = styled.a`
  text-decoration: none;
  color: rgba(0, 0, 0, .7);
  transition: 250ms ease;
  display: block;
  text-align: center;
  margin-top: -2rem;
  z-index: 105;
  position: relative;

  &:hover {
    color: ${props => props.theme.primaryColor || '#007bff'};
  }
`;

const InfoBlock = styled.div`
  background-color: #fff;
  padding: 2rem 0;
  width: 100%;
  text-align: left;
  position: relative;
  z-index: 10;
`;

const ContentWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;

  @media(min-width: 768px) {
    width: 80%;
    padding: 0;
  }
`;

const TitleText = styled.h2`
  font-family: 'Raleway', sans-serif;
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #111;

  @media (max-width: 575px) {
    font-size: 1.3rem;
  }
`;

const DescriptionText = styled.p`
  font-size: 1rem;
  font-family: 'Raleway', sans-serif;
  color: #333;
  line-height: 1.6;
  margin-bottom: 2rem;
  white-space: pre-line;

  @media (max-width: 575px) {
    font-size: 1rem;
  }
`;

const Hero = () => {
  const state = useContext(context);

  useEffect(() => {
    gsap.from(".hero-animate", {
      opacity: 0,
      y: 10,
      duration: 1,
      ease: "back.out(1.7)",
      stagger: 0.25,
    });

    gsap.to("#downButton", {
      y: -20,
      repeat: -1,
      yoyo: true,
      duration: 1.5,
    });
  }, []);

  return (
    <MainCont>
      <HeroImageWrapper className="hero-animate">
        <HeroImage $image={heroImage} />
        <VideoOverLay />
        <DownLink id="downButton" href="#formSearch" className="hero-animate">
          <ArrowDownOutlined />
        </DownLink>
      </HeroImageWrapper>

      <InfoBlock className="hero-animate" id="formSearch">
        <ContentWrapper>
          <TitleText>PM PROPIEDADES · CORREDORA INMOBILIARIA</TitleText>
          <DescriptionText>
            PM Propiedades es una corredora boutique que combina atención cercana con tecnología avanzada.
            Nos especializamos en conectar personas con espacios únicos, bien ubicados y pensados para vivir mejor.
            Contamos con clientes calificados listos para visitar tu propiedad en venta o arriendo.
            Confía en una corredora distinta. Confía en PM Propiedades.
          </DescriptionText>
          <FormProperty />
        </ContentWrapper>
      </InfoBlock>
    </MainCont>
  );
};

export default Hero;